import Vue from 'vue'
import Focusable from './focusable'
import VueCookies from 'vue-cookies'
import VueScrollTo from 'vue-scrollto'
import { VBTogglePlugin, PopoverPlugin } from 'bootstrap-vue'
import VueSocialSharing from 'vue-social-sharing'

export default function load() {
	Vue.use(Focusable)
	Vue.use(PopoverPlugin)
	Vue.use(VueCookies)

	Vue.use(VueScrollTo, {
		offset: -200
	})

	Vue.use(VBTogglePlugin)

	Vue.use(VueSocialSharing);
}

